import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import "./TourLogin.css";
import "../../styles/font.css";

import { LoginArea } from "../../component/LoginArea";
import {TopMenuEmpty} from "../../component/TopMenuEmpty";
import { API_CONFIG } from '../../config/api';

export const TourLogin = () => {
  function getCookie(name) {
    let cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('user'); // 'user' 또는 'artist'
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogout = () => {
    // 모든 사용자 관련 쿠키 삭제
    document.cookie = "yournest_u_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";

    // 모든 작가 관련 쿠키 삭제
    document.cookie = "yournest_a_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_profile=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_company=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_description=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_type=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_address=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lat=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lng=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
  };

  const handleLogin = async () => {
    try {
      const endpoint = activeTab === 'user' ? '/tour_user_login' : '/tour_artist_login';
      const loginData = activeTab === 'user' 
        ? { user_login_id: username, user_login_pw: password }
        : { artist_login_id: username, artist_login_pw: password };

      const response = await fetch(`${API_CONFIG.MAIN}${endpoint}`, {    
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(loginData),
      });

      if (response.ok) {
        handleLogout();
        const data = await response.json();
        if (activeTab === 'user') {
          document.cookie = `yournest_u_id=${data.id}; path=/`;
          document.cookie = `yournest_u_login_id=${data.user_login_id}; path=/`;
          document.cookie = `yournest_u_name=${data.user_name}; path=/`;
          document.cookie = `yournest_u_email=${data.user_email}; path=/`;
          document.cookie = `yournest_u_phone=${data.user_phone}; path=/`;
          document.cookie = `yournest_u_auth_token=${data.auth_token}; path=/`;
        } else {
          document.cookie = `yournest_a_id=${data.id}; path=/`;
          document.cookie = `yournest_a_login_id=${data.artist_login_id}; path=/`;
          document.cookie = `yournest_a_name=${data.artist_name}; path=/`;
          document.cookie = `yournest_a_profile=${data.artist_profile}; path=/`;
          document.cookie = `yournest_a_company=${data.artist_company}; path=/`;
          document.cookie = `yournest_a_email=${data.artist_email}; path=/`;
          document.cookie = `yournest_a_phone=${data.artist_phone}; path=/`;
          document.cookie = `yournest_a_description=${data.artist_description}; path=/`;
          document.cookie = `yournest_a_type=${data.artist_type}; path=/`;
          document.cookie = `yournest_a_address=${data.artist_address}; path=/`;
          document.cookie = `yournest_a_lat=${data.artist_lat}; path=/`;
          document.cookie = `yournest_a_lng=${data.artist_lng}; path=/`;
          document.cookie = `yournest_a_auth_token=${data.auth_token}; path=/`;
        }
        alert('로그인에 성공하였습니다');
        navigate('/');
      } else {
        alert('로그인에 실패하셨습니다. 아이디와 패스워드를 확인하세요');
      }
    } catch (error) {
      console.error("요청 중 에러 발생:", error);
    }
  };

  return (
    <div className="tour-login">
      <TopMenuEmpty />
      <LoginArea 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        username={username} 
        setUsername={setUsername} 
        password={password} 
        setPassword={setPassword} 
        handleLogin={handleLogin} 
      />
    </div>
  );
};
